import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const unauthorizedRoute: RouteConfig<'with-page'> = {
    name: 'Error - 401',
    path: '/errors/401',
    page: lazy(() => import('.')),
}